import { createSlice } from "@reduxjs/toolkit";

const initialState = {};

const taskSlice = createSlice({
    name: "task",
    initialState,
    reducers: {},
});

export const {} = taskSlice.actions;
export default taskSlice.reducer;
